(function($) {

$.fn.ENet = function(options, callback) {
    
    var opts = $.extend({}, $.fn.ENet.defaults, options);

    $(this).each(function(){
        var obj = $(this);
		construct(obj);

/*
		if(callback != undefined && $.isFunction(callback)){
			callback.call(this, obj);
		}
*/
    });
    
    function construct(obj) {
    	obj.empty();
    	var articleList = $('<ul class="article-list"></ul>');
    	
    	obj.append(articleList);
    	var existingListXHR;
    	var existingPaginationXHR;
    	
		var page = 0; // current page of results, for skipping pages of results, in chunks of the max var
		var paginationPage = 0;
		var maxPages = 0;
		var total = 0;
		var max = 10;
    	var searchTerms = '';
    	
    	var showSummary = true;
    	var showThumbnail = true;
    	var showDate = true;
    	var showTime = true;
    	var showSearch = false;
    	var cmsFragmentID = 0; // if this is > 0, append ?cmsapifragment=1234 to all of the e-net article links. This instructs e-net to pull in that cms fragment and add it to the article sidebar
    	var appendDatePublished = false;
    	var noLinks = false; // this prevents any links from being rendered. This is used when the webpage is going to appear on a digital sign, to prevent users from clicking away from the content intended to be displayed on the sign.
    	
    	if (obj.attr('data-summary') != undefined) {
    		showSummary = obj.attr('data-summary').toString() == 'true';
    	}
    	
    	if (obj.attr('data-nolinks') != undefined) {
    		noLinks = obj.attr('data-nolinks').toString() == 'true';
    	}
    	
    	if (obj.attr('data-cmsfragmentid') != undefined && obj.attr('data-cmsfragmentid') !== '') {
    		cmsFragmentID = parseInt(obj.attr('data-cmsfragmentid'));
    	}
    	
    	if (obj.attr('data-showtime') != undefined) {
    		showTime = obj.attr('data-showtime').toString() == 'true';
    	}
    	
    	if (obj.attr('data-showdate') != undefined) {
    		showDate = obj.attr('data-showdate').toString() == 'true';
    	}
    	
    	if (obj.attr('data-thumbnail') != undefined) {
    		showThumbnail = obj.attr('data-thumbnail').toString() == 'true';
    		
    		if (showThumbnail === false) {
    			articleList.addClass('no-thumbs');
    		}
    	}
    	
    	if (obj.attr('data-search') != undefined) {
			showSearch = obj.attr('data-search').toString() == 'true';
    	}
    	
    	if (obj.attr('data-datepublished') != undefined) {
    		appendDatePublished = obj.attr('data-datepublished').toString() == 'true';
    	}
    	
    	if (showSearch == true) {
				
				if (obj.attr('data-calOnly') == 'true') {
					var searchInput = $('<input class="enet-feed--search-bar" type="text" placeholder="Search Events">');
				} else {
					searchInput = $('<input class="enet-feed--search-bar" type="text" placeholder="Search Articles">');
				}
    		
    		searchInput.keyup(function(){
				searchTerms = $(this).val();
				load();
    		});
    		
    		if (obj.find('.enet-feed--search-bar').size() == 0) {
    			obj.prepend(searchInput);
    		}
    	}
    	
    	function getQuery() {
    		var query = '?widget=true';
    	
			if (obj.attr('data-max'))
			{
				max = parseInt(obj.attr('data-max'));
				query += '&max=' + max;
			}
		
			if (obj.attr('data-days'))
			{
				query += '&days=' + obj.attr('data-days');
			}
		
			if (obj.attr('data-departments'))
			{
				var depts_obj = obj.attr('data-departments');
				var depts_obj_clean = depts_obj.replace(/\s+/g, '');
				query += '&departments=' + depts_obj_clean;
			}
		
			if (obj.attr('data-sections'))
			{
				query += '&sections=' + obj.attr('data-sections');
			}
		
			if (obj.attr('data-taggedEmployee'))
			{
				query += '&taggedEmployee=' + obj.attr('data-taggedEmployee');
			}
			if (obj.attr('data-priority'))
			{
				query += '&priority=' + obj.attr('data-priority');
			}
		
			if (obj.attr('data-calOnly') != undefined)
			{
				query += '&calOnly=' + obj.attr('data-calOnly');
			}

			if (obj.attr('data-excludeCal') != undefined)
			{
				query += '&excludeCal=' + obj.attr('data-excludeCal');
			}

			if (obj.attr('data-calStartDate'))
			{
				query += '&calStartDate=' + obj.attr('data-calStartDate');
			}

			if (obj.attr('data-calEndDate'))
			{
				query += '&calEndDate=' + obj.attr('data-calEndDate');
			}
			if (obj.attr('data-pubStartDate'))
			{
				query += '&pubStartDate=' + obj.attr('data-pubStartDate');
			}

			if (obj.attr('data-pubEndDate'))
			{
				query += '&pubEndDate=' + obj.attr('data-pubEndDate');
			}

			if (obj.attr('data-order'))
			{
				query += '&forceOrder=' + obj.attr('data-order');
			}
			
			query += '&searchTerms=' + searchTerms;
			
			return query;
    	}
    	
    	function loadPagination() {
			if (String(obj.attr('data-paginate')) == 'true') { // Changed from .toString() to String()
				var pagination = $('<ul class="pagination"></ul>');
				
				obj.find('.pagination').remove();
				obj.append(pagination);
				
				if (existingPaginationXHR) {
					existingPaginationXHR.abort();
				}
				
				existingPaginationXHR = $.get('https://www.elon.edu/e-net/feed/total' + getQuery(), function(data) {
					total = parseInt(data);
	
					var pages = Math.ceil(total/max);

					pagination.empty();
	
					var minPages = pages;
					
					// if there's only one page of results (or none -- which might happen when searching), hide the pagination
					if (minPages == 0 || minPages == 1) {
						obj.find('.pagination').hide();
					
					// else do all the pagination logic and show pagination
					} else {
						
						if (obj.attr('data-maxpages')) {
							maxPages = parseInt(obj.attr('data-maxpages'));
							minPages = Math.min(pages, maxPages);

							var prev = $('<li><a href="#"><span class="sr-only">Previous E-Net Page</span><i class="fa fa-chevron-left" aria-hidden="true"></i></a></li>');

							prev.click(function() {
								paginationPage--;
								loadPagination();
								return false;
							});

							if (paginationPage > 0) {
								pagination.append(prev);
							}
						}
						
						for(var i = 0; i < minPages; i++) {
							var realPageNum = i + (paginationPage * maxPages);

							if (realPageNum <= pages+1) {
								var pageLink = $('<a href="#" data-page="' + (realPageNum) + '">' + (realPageNum+1) + '</a>');

								pageLink.click(function(){
									page = parseInt($(this).attr('data-page'));
									load();

									$('html, body').animate({
										scrollTop: obj.offset().top
									}, 0);

									return false;
								});

								var li = $('<li></li>');

								li.append(pageLink);
								pagination.append(li);

								if (page == realPageNum) {
									li.addClass('current');
									li.find('a');
								}
							}
						}
						
						if (obj.attr('data-maxpages')) {
							var next = $('<li><a href="#"><span class="sr-only">Next E-Net Page</span><i class="fa fa-chevron-right" aria-hidden="true"></i></a></li>');

							next.click(function(){
								paginationPage++;
								loadPagination();
								return false;
							});

							if (pages > ((paginationPage+1) * maxPages)) {
								pagination.append(next);
							}
						}
					}
				});
			}
    }
    	
		function load() {
			var ul = obj.find('ul.article-list').empty();
			obj.find('.loading').remove();
			ul.before('<p class="loading"><i class="fa fa-spinner fa-pulse"></i><span class="sr-only>Loading</span></p>');
			
			if (existingListXHR) {
				existingListXHR.abort();
			}
			
			existingListXHR = $.getJSON('https://www.elon.edu/e-net/feed/json' + getQuery() + '&page=' + page, function(data) { // Need to removed the http://www.elon.edu
				
				obj.find('.loading').remove();
				
				if (data.length) {
					$.each(data, function(key, article) {
					
						var li = $('<li></li>');
					
						var url = '';
					
						if (document.domain.indexOf('elon.edu') > -1) {
							url = '/e-net/Article/' + article.ArticleId;
						} else {
							url = 'https://www.elon.edu/e-net/Article/' + article.ArticleId
						}
					
						if (cmsFragmentID > 0) {
							url += '?cmsapifragment=' + cmsFragmentID;
						}
					
						var item = $('<article><a href="' + url + '"><h1 class="headline">' + article.Headline + '</h1></a></article>');
					
						if (appendDatePublished) {
							item.find('a').first().append('<span class="date_pub">published ' + article.DatePublished + '</span>');
						}
					
					
						/*
					
						general logic outline for the rendering of thumbnails and calendar items
					
						if (showThumb) {
							if (hasDate) {
								render calendar box
							} else {
								render thumbnail
							}
						} else {
							append date and time to headline
						}
						*/

						if (showThumbnail === true) {
						
							// sort by CalItems, filter out ones that have already passed, then use the next most upcoming item as the source of data for this display
							
							if (article.CalItems && article.CalItems.length > 1) {
								article.CalItems = article.CalItems.filter(function(item){
									return new Date(item.StartDate + ' ' + item.StartTime) > new Date();
								});
							}
						
							if (article.CalItems[0]) {
								// render calendar box
							
								li.addClass('cal-item');
							
								var first_cal_item = article.CalItems[0];
								var startDate = first_cal_item.StartDate;
								var startTime = first_cal_item.StartTime;
							
								var calBox = $('<div class="cal-box"></div>');
							
								var month = startDate.split('/')[0];
								var monthText = '';
							
								switch (month) {
									case '1':
										monthText = 'Jan';
										break;
									case '2':
										monthText = 'Feb';
										break;
									case '3':
										monthText = 'Mar';
										break;
									case '4':
										monthText = 'Apr';
										break;
									case '5':
										monthText = 'May';
										break;
									case '6':
										monthText = 'Jun';
										break;
									case '7':
										monthText = 'Jul';
										break;
									case '8':
										monthText = 'Aug';
										break;
									case '9':
										monthText = 'Sep';
										break;
									case '10':
										monthText = 'Oct';
										break;
									case '11':
										monthText = 'Nov';
										break;
									case '12':
										monthText = 'Dec';
										break;
								}
							
								var monthBox = $('<span class="cal-month">' + monthText + '</span>');
								var dayBox = $('<span class="cal-day">' + startDate.split('/')[1] + '</span>');
								var yearBox = $('<span class="cal-year">' + startDate.split('/')[2] + '</span>');
								var timeBox = $('<span class="cal-time">' + startTime + '</span>');

								calBox.append(monthBox);
								calBox.append(dayBox);
								calBox.append(yearBox);
							
								if (showTime === true) {
									calBox.append(timeBox);
								}
							
								item.find('a').prepend(calBox);
							
							} else if (article.ThumbnailImage > 0) {
								// if it doesn't have a calendar item, then render the thumbnail image
								var imgWrap = $('<span class="enet-thumb-wrap"></span>');
								imgWrap.append('<img class="enet-thumb" alt="" src="//www.elon.edu/e-net/GetImage.ashx?w=400&amp;crop=true&amp;id=' + article.ThumbnailImage + '"/>');
								item.find('a').prepend(imgWrap);
							} else {
								item.find('a').prepend('<div class="enet-no-thumb"></div>');
							}
						} else {
							if (article.CalItems[0]) {
								// if no thumbnail but it's a calendar item, prepend the headline with the date and time
							
								var first_cal_item = article.CalItems[0];
						
								if (showTime === true) {
									var calTimeEl = $('<span class="time-prefix">' + first_cal_item.StartTime + '</span>');
									item.find('.headline').after(calTimeEl);
								}
						
								if (showDate === true) {
									var calDateEl = $('<span class="date-prefix">' + first_cal_item.StartDate + '</span>');
									item.find('.headline').after(calDateEl);
								}
							
							}
						}
					
						if (showSummary === true) {
					
							try {
								if ($(article.Summary)[0] === undefined) { // must be a pure text node
									item.append('<p class="summary">' + article.Summary + '</p>');
								} else {
									item.append('<div class="summary">' + article.Summary + '</div>');
								}
							} catch(err){ // must be a pure text node. If $(article.Summary) doesn't parse as a valid jQuery selector, it must be a pure text node
								item.append('<p class="summary">' + article.Summary + '</p>');
							}
					
						}
					
						li.append(item);
				
						ul.append(li);
					});
				} else if (page === 0 && searchTerms === '') {
					if (obj.attr('data-calOnly') == 'true') {
						ul.append('<li class="enet-no-results enet-no-results--calendar"><p class="no-results-icon"><i class="fa fa-calendar-times-o"></i></p><p class="typeset-as-h4 text--sans-serif-alt">No Upcoming Events</p><p>There are no events scheduled at this time.</p></li>');
					} else {
						obj.hide();
					}
				} else {
					if (obj.attr('data-calOnly') == 'true') {
						ul.append('<li class="enet-no-results enet-no-results--calendar"><p class="no-results-icon"><i class="fa fa-calendar-times-o"></i></p><p class="typeset-as-h4 text--sans-serif-alt">No Events Found</p><p>There are no results matching your search.</p></li>');
					} else {
						ul.append('<li class="enet-no-results enet-no-results--articles"><p class="no-results-icon"><i class="fa fa-newspaper-o"></i></p><p class="typeset-as-h4 text--sans-serif-alt">No Articles Found</p><p>There are no results matching your search.</p></li>');
					}
				}
				
				if (noLinks === true) {
					$('a', obj).contents().unwrap();
				} else {
					loadPagination();
				}
				
				if(callback != undefined && $.isFunction(callback)){
					callback.call(this, obj);
				}
			});
		}
		
		load();
    }
};

$.fn.ENet.defaults = {
    maxPages: 10
};

})(jQuery);